import React from "react";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import app from "..";
import { ReactComponent as AppleIcon } from "./apple_icon.svg";
import "./apple_login_button.css";
import { useTranslation } from "react-i18next";

const AppleLoginButton = ({ callback }) => {
  const { t } = useTranslation();
  const handleAppleLogin = async () => {
    const auth = getAuth(app);
    try {
      const provider = new OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const idToken = await user.getIdToken();
      callback({
        idToken: idToken,
        email: user.email,
        lang: navigator.language,
      });
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  return (
    <button className="apple-signin-button" onClick={handleAppleLogin}>
      <AppleIcon
        className="Apple-logo"
        style={{ marginRight: "5px" }}
      ></AppleIcon>
      {t("sign_in_with_apple")}
    </button>
  );
};

export default AppleLoginButton;
